export enum PollingDelay {
  DEFAULT = 10000,
  ON_ERROR = 60000
}
